import gql from "graphql-tag";
import PostReplyFields from "../../fragments/engagement/PostReplyFields";

export default gql`
  mutation EditPostReply($objectId: ID!, $bodyAsJson: JSON!, $bodyAsPlainText: String!) {
    editPostReply(objectId: $objectId, bodyAsJson: $bodyAsJson, bodyAsPlainText: $bodyAsPlainText) {
      ...PostReplyFields
    }
  }

  ${PostReplyFields}
`;
